import { createFileRoute, Navigate } from '@tanstack/react-router';
import { AuthCheck } from '@/components/auth-check.component';
import { Head } from '@/components/head.component';
import { CallingSettings } from '@/containers/settings/calling/calling-settings.component';
import { useCallingAccess } from '@/containers/settings/calling/use-calling-access.hook';
import { SettingsLayout } from '@/containers/settings/settings-layout.component';

export const Route = createFileRoute('/settings/calling')({
  component: () => (
    <>
      <Head heading='Calling' />
      <AuthCheck>
        <SettingsLayout>
          <CallingPage />
        </SettingsLayout>
      </AuthCheck>
    </>
  ),
});

// An org without calling (flag off, or a plan without it) lands on Account
// once the answer is in, never on an empty pane.
function CallingPage() {
  const { enabled, ready } = useCallingAccess();
  if (ready && !enabled) return <Navigate to='/settings/account' replace />;
  if (!enabled) return null;
  return <CallingSettings />;
}
